import React from 'react'
import { getMessage } from '../../../utils'
import { Button } from 'primereact/button'
import storage from '../../../services/stoage.service'
import LtsCurrency from '../../../components/lottus/lts-currency'
import LtsInputNumber from '../../../components/lottus/lts-input-number'
import { icons } from '../../../constants'

export default function ConfigDescontoAilos(props) {
  const messages = storage.getAppLabels('configuracaoboleto')

  const parseValue = (value) => {
    if (!value) return { descontos: [] }
    if (typeof value === 'object') return value
    if (typeof value !== 'string') return { descontos: [] }
    try {
      return JSON.parse(value) || {}
    } catch (e) {
      return { descontos: [] }
    }
  }

  const data = parseValue(props.value)
  const descontos = Array.isArray(data.descontos) ? data.descontos : []

  const emit = (nextDescontos) => {
    const next = { ...data, descontos: nextDescontos }
    if (props.onChange) props.onChange(JSON.stringify(next))
  }

  const addDesconto = () => {
    emit([...(descontos || []), { valor: null, diasAteVencimento: null }])
  }

  const removeDesconto = (index) => {
    emit((descontos || []).filter((_, i) => i !== index))
  }

  const updateDesconto = (index, field, value) => {
    const next = (descontos || []).map((d, i) => {
      if (i !== index) return d
      return { ...(d || {}), [field]: value }
    })
    emit(next)
  }

  return (
    <>
      <div className="p-col-12">
        <Button
          type="button"
          icon={icons.PLUS_ICON}
          label={getMessage(messages, 'configuracaoboleto.label.adicionardesconto')}
          className="p-button-success"
          style={{ width: 'auto' }}
          onClick={addDesconto}
        />
      </div>

      {(descontos || []).map((desconto, index) => (
        <React.Fragment key={index}>
          <div className="p-col-12 p-md-5">
            <LtsCurrency
              value={desconto?.valor ?? null}
              onChange={(e) => updateDesconto(index, 'valor', e)}
              name={`descontoAilosValor_${index}`}
              label={getMessage(messages, 'configuracaoboleto.label.valordesconto')}
            />
          </div>

          <div className="p-col-12 p-md-5">
            <LtsInputNumber
              name={`descontoAilosDias_${index}`}
              value={desconto?.diasAteVencimento ?? null}
              onChange={(e) => updateDesconto(index, 'diasAteVencimento', e)}
              label={getMessage(messages, 'configuracaoboleto.label.diasatevencimentodesconto')}
              format={false}
            />
          </div>

          <div className="p-col-12 p-md-2" style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              type="button"
              icon={icons.REMOVE_ICON}
              className="p-button-danger"
              onClick={() => removeDesconto(index)}
            />
          </div>
        </React.Fragment>
      ))}
    </>
  )
}
